import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import STPLogo from "./../../images/logo.svg";
import { Divider, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { getCurrentVersion } from "../../utils/versionControl";
import { Link } from "react-router-dom";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(1.5)" }}
  >
    •
  </Box>
);

const NotasVersion = () => {
  return (
    <Grid2 container spacing={2} justifyContent="center">
      <Grid2 md={7} sx={{ textAlign: "center", marginTop: 3 }}>
        <img src={STPLogo} height={100} />
      </Grid2>
      <Grid2 md={7} sx={{ textAlign: "center" }}>
        <Typography color="secondary" component="div" variant="h3">
          Sistema de Gestión de Cargas (SGDC)
        </Typography>
      </Grid2>
      <Grid2 md={7} sx={{ textAlign: "center" }}>
        <Typography component="div" variant="body">
          Desarrollo de Ingeniería 🇨🇱 - Departamento de Operaciones y Estudios
        </Typography>
      </Grid2>
      <Grid2 md={7}>
        <Divider>
          {" "}
          <Link to="/login">
            <Typography component="div" variant="body">
              Regresar a login...
            </Typography>
          </Link>
        </Divider>
      </Grid2>
      <Grid2 md={7} sx={{ textAlign: "left" }}>
        <Typography component="div" variant="h3">
          Novedades {getCurrentVersion()}
        </Typography>
      </Grid2>
      <Grid2 md={7} sx={{ textAlign: "justify", paddingLeft: 3 }}>
        <Typography component="div" variant="body">
          {bull} Nuevo menú reportes, ahora se pueden generar reportes en una
          pistolas y deshabilitarla, además de adjuntar fotos.
        </Typography>
      </Grid2>
      <Grid2 md={7} sx={{ textAlign: "justify", paddingLeft: 3 }}>
        <Typography component="div" variant="body">
          {bull} Registro de socket, ahora puedes especificar que socket tiene
          un bus determinado, lo que permitirá llevar un estudio de este.
        </Typography>
      </Grid2>
      <Grid2 md={7} sx={{ textAlign: "justify", paddingLeft: 3 }}>
        <Typography component="div" variant="body">
          {bull} Registro de marcaje, ahora al marcar una pistola como
          'especial' o 'bajo estudio' se registrará dicho cambio con el fin de
          poder llevar un estudio.
        </Typography>
      </Grid2>

      <Grid2 md={7}>
        <Divider>
          {" "}
          <Link to="/login">
            <Typography component="div" variant="body">
              Regresar a login...
            </Typography>
          </Link>
        </Divider>
      </Grid2>
    </Grid2>
  );
};

export default NotasVersion;
